var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParetiDivisorie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    id: "svg1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    id: "rect1",
    width: 15.876312,
    height: 21.253819,
    x: 9.1268978,
    y: 23.739286
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4",
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "M 24.994141 5.0097656 L 24.994141 14.375 L 32.9375 14.375 L 32.9375 26.263672 L 40.869141 26.263672 L 40.869141 5.0097656 L 24.994141 5.0097656 z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect3",
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "M 17.060547 14.375 L 17.060547 23.740234 L 25.003906 23.740234 L 25.003906 35.628906 L 32.9375 35.628906 L 32.9375 14.375 L 17.060547 14.375 z "
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeLinecap: "square",
      strokeOpacity: 1,
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect5",
    width: 12.60299,
    height: 6.3873739,
    x: 10.763559,
    y: 25.372999
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeLinecap: "square",
      strokeOpacity: 1,
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect6",
    width: 12.60299,
    height: 6.3873739,
    x: 18.697529,
    y: 16.027
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeLinecap: "square",
      strokeOpacity: 1,
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    id: "rect7",
    width: 12.60299,
    height: 6.3873739,
    x: 26.630146,
    y: 6.6960001
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "M 9.3082054,23.210703 24.576475,5.1882046",
    id: "path7"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParetiDivisorie);
export default __webpack_public_path__ + "static/media/pareti_divisorie.1d7a2855c8bdcd1e9e561c74feaec4e9.svg";
export { ForwardRef as ReactComponent };